<template>
<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
               
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    v. Beta 0.0.30
                    <!--Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesdesign-->
                </div>
            </div>
        </div>
    </div>
</footer>
</template>